<template>
  <div class="offer-section py-5">
    <div class="container">
      
      <div class="row">
        <div class="col-md-6 d-flex align-items-center">
          <div class="choose-text">
            <h3 class="mb-3">Why Choose Us?</h3>
            <p>As a leading tech training centre, we are passionate about providing cutting-edge training programs that help individuals and organizations thrive in the ever evolving digital landscape.</p>
          </div>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <img src="../../assets/Images/home/choose.png" class="img-fluid" alt="">
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-12 mb-3" v-for="reason in reasons" :key="reason.id">
          <div class="border border-primary rounded">
            <div class="image-box">
              <img
                :src="
                  require(`../../assets/Images/home/${reason.image_src}.png`)
                "
                class="w-100"
                alt=""
              />
            </div>
            <div class="p-3">
              <p class="mb-0 text-primary">{{ reason.title }}</p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reasons: [
        {
          id: 1,
          text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sin.",
          title: "24 Hours Technical Support",
          image_src: "type",
        },
        {
          id: 2,
          text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sin.",
          title: "24 Hours Technical Support",
          image_src: "computer",
        },
        {
          id: 3,
          text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sin.",
          title: "24 Hours Technical Support",
          image_src: "people",
        },
      ],
    };
  },
};
</script>

<style scoped>
.choose-text {
  width: 65%;
}

@media (max-width: 426px) {
  .choose-text {
  width: 100%;
}
}
</style>